export default __webpack_public_path__ + "static/media/Button-Delete.bc68fb25.svg";